import React             from 'react';
import WizardFormContext from '@widesk-ui/contexts/WizardFormContext';

export default function useWizardForm() {
	return React.useContext(WizardFormContext);
}
